type AppLocale = 'tw' | 'en'

/** 依瀏覽器語系回傳專案使用的 locale 代碼 */
export const useLocale = (): AppLocale | undefined => {
  const browserLocaleMap: Record<string, AppLocale> = {
    'zh-TW': 'tw', // 繁體中文
    en: 'en' // 英文
  }

  // 依優先順序取得瀏覽器語系列表
  const browserLanguages =
    navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language]

  // 找到第一個對應的專案語系，例如 zh-TW -> tw、en-US -> en
  for (const browserLanguage of browserLanguages) {
    const matchedLocaleKey = Object.keys(browserLocaleMap).find((localePrefix) =>
      browserLanguage.startsWith(localePrefix)
    )

    if (matchedLocaleKey) {
      return browserLocaleMap[matchedLocaleKey]
    }

    // 目前只檢查最高優先的瀏覽器語系
    break
  }

  // 若沒有可用語系，交由 i18n fallbackLocale 處理
  return undefined
}
